<template lang="html">
  <!-- Content -->
  <d-row>
    <d-col>
      <d-card class="card-small mb-4">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center justify-content-between">
            <d-col cols="12" lg="6">
              <h6 class="m-0">Dados cadastrais</h6>
            </d-col>
            <d-col cols="12" lg="2" class="d-flex justify-content-end align-items-center" v-if="lead.score">
              <b-badge variant="light" class="score-badge">
                <span class="score-label">Pontuação:</span>
                <span class="score-value">{{ lead.score }}</span>
              </b-badge>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <lead-form ref="leadForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col lg="3" md="12" v-if="isAdmin">
      <sidebar-actions :model.sync="lead" @toggleSpam="toggleSpam" />
      <assigned-distributors :distributors="lead.resellers" />
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import LeadForm from './LeadForm.vue';
import SidebarActions from './SidebarActions.vue';
import LeadActions from './LeadActions';
import AssignedDistributors from './AssignedDistributors.vue';

export default {
  name: 'lead-page',
  mixins: [LeadActions],
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  components: {
    LeadForm,
    SidebarActions,
    AssignedDistributors,
  },
  methods: {
    ...mapActions(['checkAdmin']),
  },
  mounted() {
    this.checkAdmin();
  },
};
</script>
<style lang="css" scoped>
.score-badge {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 6px 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.score-label {
  font-size: 12px;
  font-weight: 600;
  color: #555555;
}

.score-value {
  font-size: 14px;
  font-weight: 700;
  color: #000000;
}

</style>
